"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const env_1 = require("../env");
function prefixIfDev(property) {
    return `${(0, env_1.isDebug)() ? 'dev-' : ''}${property}`;
}
exports.default = prefixIfDev;
